export default function icon(name: string): string {
  return `<svg class="icon icon-${name}"><use xlink:href="#icon-${name}"></use></svg>`;
}
